import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './auth/AuthProvider';
import { AppRoutes } from './routes';

export function App() {
  const { ready } = useAuth();
  if (!ready) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  return <AppRoutes />;
}
